import DatePreview from "../../QuestionPreviews/DatePreview/DatePreview";

const DateQuestion = ({ question }) => {
  const { isActive } = question;

  return <>{!isActive && <DatePreview question={question} />}</>;
};

export default DateQuestion;
